function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* ========================================================================
 * Apricot's Event Timeline
 * ======================================================================== */

// SCSS
import "../scss/includes/apricot-base.scss";
import "../scss/includes/event-timeline.scss";

// javaScript
import Utils from "./CBUtils";

/**
 * Event Timeline
 *
 * @export
 * @param {Object} data
 * @param {Element} data.elem
 * @returns {{destroy: Function}}
 *
 */
var EventTimeline = function EventTimeline() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultData = {
    elem: null
  };
  data = _objectSpread(_objectSpread({}, defaultData), data);
  var elem = data.elem;
  if (!Utils.elemExists(elem)) return null;
  var init = function init() {
    elem.eventTimelinePlugin = "cb";
    if (Utils.hasClass(elem, "cb-event-cards-horizontal")) {
      elem.querySelectorAll(".cb-card").forEach(function (card) {
        if (card.querySelector(".cb-card-label")) {
          Utils.addClass(card, "cb-has-label");
        }
      });

      // Utils.breakpoints()
      // adjustCardHeight(Utils.viewport().prefix)
      // document.addEventListener('apricot_breakpointChange', function (e) {
      //   const data = e.data

      //   adjustCardHeight(data.prefix)
      // })
    }

    a11y();
  };
  var a11y = function a11y() {
    var items = elem.querySelectorAll(".cb-card");
    items.forEach(function (item) {
      var year = item.querySelector(".cb-event-year");
      var yearId = "";
      if (year) {
        yearId = Utils.attr(year, "id") ? Utils.attr(year, "id") : Utils.uniqueID(5, "apricot_");
        Utils.attr(year, "id", yearId);
      }
      var header = item.querySelector(".cb-card-header");
      var headerId = "";
      if (header) {
        headerId = Utils.attr(header, "id") ? Utils.attr(header, "id") : Utils.uniqueID(5, "apricot_");
        Utils.attr(header, "id", headerId);
      }
      var title = item.querySelector(".cb-card-title");
      var titleId = "";
      if (title) {
        titleId = Utils.attr(title, "id") ? Utils.attr(title, "id") : Utils.uniqueID(5, "apricot_");
        Utils.attr(title, "id", titleId);
      }
      var links = item.querySelectorAll(".cb-card-action .cb-btn");
      links.forEach(function (link) {
        Utils.attr(link, "aria-describedby", "".concat(yearId, " ").concat(headerId, " ").concat(titleId));
      });
    });
  };
  var destroy = function destroy() {
    if (elem.eventTimelinePlugin === "cb") {
      elem.eventTimelinePlugin = null;
    }
  };
  if (elem.eventTimelinePlugin !== "cb") {
    init();
  }
  return {
    destroy: destroy
  };
};
export default EventTimeline;